import React, { createElement } from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { FileTextIcon, DownloadIcon, CalendarIcon } from 'lucide-react';
interface DocumentCardProps {
  title: string;
  description: string;
  version?: string;
  date: string;
  documentUrl: string;
  featured?: boolean;
  index: number;
}
export function DocumentCard({
  title,
  description,
  version,
  date,
  documentUrl,
  featured,
  index
}: DocumentCardProps) {
  const handleDownload = async () => {
    try {
      const response = await fetch(documentUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // Build a friendly filename from the document title
      const safeName = title.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
      link.download = `${safeName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      // Fallback: open the URL directly in a new tab
      window.open(documentUrl, '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} data-id="element-336">
      <Card hover className={featured ? 'border-2 border-au-green' : ''} data-id="element-337">
        <div className="flex items-start gap-4" data-id="element-338">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${featured ? 'bg-au-green' : 'bg-au-green-light'}`} data-id="element-339">
            <FileTextIcon size={24} className={featured ? 'text-white' : 'text-au-green'} data-id="element-340" />
          </div>
          <div className="flex-1" data-id="element-341">
            <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-342">{title}</h3>
            <p className="text-sm text-gray-600 mb-3" data-id="element-343">{description}</p>
            <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-id="element-344">
              {version && <span data-id="element-345">Version {version}</span>}
              <div className="flex items-center gap-1" data-id="element-346">
                <CalendarIcon size={14} data-id="element-347" />
                <span data-id="element-348">{new Date(date).toLocaleDateString('en-GB')}</span>
              </div>
            </div>
            <Button variant="secondary" onClick={handleDownload} className="flex items-center gap-2 text-sm" data-id="element-349">
              <DownloadIcon size={16} data-id="element-350" />
              Download PDF
            </Button>
          </div>
        </div>
      </Card>
    </motion.div>;
}